export default "__VITE_ASSET__uC7RrA9N__"